module.exports = __webpack_public_path__ + "img/lucid-motors-logo.1dbf925f.webp";